var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book_today"},[_c('div',{staticClass:"container"},[_c('a',{attrs:{"href":_vm.parsedCta.url,"target":_vm.parsedCta.target},domProps:{"innerHTML":_vm._s(_vm.parsedCta.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib?{}!./scripts/vue/BookToday.vue?vue&type=template&id=b2af87ba&scoped=true&
// module id = 180
// module chunks = 0